import React from "react";
import PropTypes from "prop-types";

import { Link } from "widgets/navigation";

import { useAccountStore } from "@/common/libs/stores";

import styles from "./topnav.css";

AccountLogo.propTypes = {
  redirectTo: PropTypes.string,
  className: PropTypes.string
};

export function AccountLogo({ redirectTo = "/", className }) {
  const companyLogo = useAccountStore((state) => state.CompanyLogo);
  return (
    <div className={`${styles.mainCompanyLogo} ${className}`}>
      <Link route={redirectTo}>
        {companyLogo && (
          <img
            className={styles.companyLogoImg}
            src={companyLogo.url}
            alt={"Company Logo"}
          />
        )}
      </Link>
    </div>
  );
}
